import fetchData from "./axios-instance";
import {forgotPasswordOptimeService} from "./new-user-auth";

const forgotPassword = async (email) => {
    const res = await forgotPasswordOptimeService(email)
    return res;
}

export default forgotPassword;